import { useState, type FormEvent } from 'react';
import { useSearchParams } from 'react-router-dom';
import { getRepo, type Article } from '../../lib/repo';
import { useAsync } from '../../lib/hooks';
import { ArticleCard } from '../../components/ArticleCard';
import { Seo } from '../../components/Seo';
import { Button, EmptyState, Input, Spinner } from '../../components/ui';

export function SearchPage() {
  const [params, setParams] = useSearchParams();
  const q = params.get('q') ?? '';
  const [draft, setDraft] = useState(q);

  const { data, loading } = useAsync<Article[]>(
    () => (q.trim() ? getRepo().listPublicArticles({ query: q.trim(), limit: 30 }) : Promise.resolve([])),
    [q],
  );

  function submit(e: FormEvent) {
    e.preventDefault();
    setParams(draft.trim() ? { q: draft.trim() } : {});
  }

  const results = data ?? [];

  return (
    <>
      <Seo name="search" />
      <div className="mx-auto max-w-4xl px-4 py-10">
        <h1 className="font-display text-3xl font-semibold">Search</h1>
        <form onSubmit={submit} className="mt-6 flex gap-2" role="search">
          <Input value={draft} onChange={(e) => setDraft(e.target.value)} placeholder="Search articles…" aria-label="Search query" />
          <Button type="submit">Search</Button>
        </form>

        <div className="mt-8">
          {loading ? <Spinner label="Searching…" /> : null}
          {!loading && q && results.length === 0 ? (
            <EmptyState title={`No results for “${q}”`} description="Try a different word, or browse the sections from the menu." />
          ) : null}
          {!loading && !q ? <p className="text-sm text-muted">Enter a term above to search the archive.</p> : null}
          {results.length ? (
            <div className="grid gap-8 sm:grid-cols-2">
              {results.map((a) => <ArticleCard key={a.id} article={a} />)}
            </div>
          ) : null}
        </div>
      </div>
    </>
  );
}
